import { H1 } from "../../components/Text/Text";
import FindCampaignBody from "./FindCampaignBody";
import FindCampaignFooter from "./FindCampaignFooter";

import styles from './styles.module.scss';

export default ({
    header: <H1>Find Campaign</H1>,
    body: <FindCampaignBody />,
    footer: <FindCampaignFooter />,
    className: styles.popupWrapper,
});